import React from 'react';

/**
 * Reusable error display component
 */
function ErrorState({ title = 'Error loading content', message }) {
  return (
    <div className="content-error">
      <h2>{title}</h2>
      {message && <p>{message}</p>}
    </div>
  );
}

export default ErrorState;
